var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategorySpa = function SvgCategorySpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.083,
    cy: 23.917,
    r: 16.917,
    fill: "#BFE8C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 45.5,
    r: 3.5,
    fill: "#BFE8C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#228856",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M39.362 17.953A15.1 15.1 0 0 1 43.167 28c0 8.376-6.79 15.167-15.167 15.167S12.834 36.377 12.834 28 19.624 12.833 28 12.833c2.871 0 5.556.798 7.845 2.184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#228856",
    strokeWidth: 1.3,
    d: "M29.685 20.136c0 .96-.615 2.738-1.32 3.937a.421.421 0 0 1-.734.002c-.703-1.176-1.317-2.881-1.317-3.94 0-1.24.755-2.247 1.686-2.247s1.685 1.006 1.685 2.247ZM26.316 35.865c0-.96.614-2.74 1.319-3.938a.421.421 0 0 1 .735-.002c.703 1.176 1.316 2.881 1.316 3.94 0 1.24-.754 2.246-1.685 2.246-.93 0-1.685-1.005-1.685-2.246ZM35.865 29.685c-.96 0-2.739-.615-3.938-1.32a.421.421 0 0 1-.001-.734c1.175-.704 2.88-1.317 3.939-1.317 1.24 0 2.247.755 2.247 1.686s-1.006 1.685-2.247 1.685ZM32.369 34.752c-.679-.678-1.502-2.371-1.852-3.717a.421.421 0 0 1 .519-.52c1.328.334 2.968 1.106 3.716 1.854.877.878 1.055 2.122.397 2.78-.658.659-1.903.48-2.78-.397ZM21.248 32.369c.679-.679 2.371-1.502 3.717-1.852a.421.421 0 0 1 .521.518c-.334 1.33-1.106 2.968-1.855 3.717-.877.877-2.122 1.055-2.78.397s-.48-1.903.397-2.78ZM34.752 23.632c-.678.678-2.37 1.502-3.717 1.851a.422.422 0 0 1-.52-.518c.334-1.329 1.106-2.968 1.854-3.717.878-.877 2.123-1.055 2.78-.397.659.658.48 1.903-.397 2.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#228856",
    d: "M38.5 16.5a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  })));
};
export default SvgCategorySpa;